import { defineMessages } from 'react-intl';

export const composerSkillToastMessages = defineMessages({
  title: {
    defaultMessage: 'Couldn’t use selected skill',
    id: 'G0J2c/i518',
    description: 'Toast title when a Work home skill cannot be invoked',
  },
  desktopRequired: {
    defaultMessage: 'This skill requires the Heidi desktop app.',
    id: 'sSfAwreCNm',
    description: 'Toast body when a skill needs the desktop app',
  },
  attachmentsPendingTitle: {
    defaultMessage: 'Uploading attachments…',
    id: 'exWXlWlMBv',
  },
  attachmentsPendingBody: {
    defaultMessage: 'Wait for uploads to finish before sending.',
    id: 'gijxfqMM8w',
  },
});

export const projectChatComposerMessages = defineMessages({
  removeFileAria: {
    defaultMessage: 'Remove {name}',
    id: 'bKrTYfV7Zr',
    description: 'Aria label for removing an attached file',
  },
  attachFiles: {
    defaultMessage: 'Attach files',
    id: 'djgCsQMRTc',
    description: 'Aria label for attaching files to the composer',
  },
  queueMessage: {
    defaultMessage: 'Queue message',
    id: 'OFSCpU1Hr9',
    description: 'Aria label for queueing a message while a turn is in flight',
  },
  sendMessage: {
    defaultMessage: 'Send message',
    id: 'MYLxviqjNc',
    description: 'Aria label for sending a composer message',
  },
  sending: {
    defaultMessage: 'Sending',
    id: 'wnzOWCDGl4',
    description:
      'Aria label for the landing composer send button while a submit is in flight',
  },
  createProject: {
    defaultMessage: 'Create project',
    id: 'W3o0ji3DQc',
    description:
      'Aria label for the landing composer send button that creates a Work project',
  },
  placeholder: {
    defaultMessage:
      'Work with Heidi, {mentionTrigger}mention context, run {routineCommand}',
    id: 'bbDJdIddjE',
    description:
      'Projects landing composer placeholder. The placeholders are literal interaction syntax and must remain unchanged.',
  },
  placeholderCompact: {
    defaultMessage: 'Ask Heidi to do anything',
    id: 'ZxGImPmhL4',
    description: 'Projects landing composer placeholder, shortened for small screens',
  },
  placeholderEvidence: {
    defaultMessage: 'Ask a clinical question',
    id: 'gwC/fcHR0j',
    description: 'Projects landing composer placeholder, Evidence mode',
  },
});

/** ICU values for `projectChatComposerMessages.placeholder` — keep in sync at every call site. */
export const PROJECT_CHAT_COMPOSER_PLACEHOLDER_VALUES = {
  mentionTrigger: '@',
  routineCommand: '/routines',
} as const;
